import { formatInt, formatMXN, formatNumber, formatPct } from "@cafe/shared";

const LABELS: Record<string, string> = {
  net_sales: "Ventas netas",
  net_sales_per_day: "Ventas netas por día",
  transactions: "Tickets",
  transactions_per_day: "Tickets por día",
  avg_ticket: "Ticket promedio",
  discounts: "Descuentos",
  gross_profit: "Utilidad bruta",
  member_share: "% con tarjeta",
  gross_sales: "Ventas brutas (antes de desc.)",
  gross_profit_before_discounts: "Utilidad antes de desc.",
  units: "Unidades",
  margin_pct: "Margen %",
  visits: "Visitas",
  visits_per_day: "Visitas por día",
  unique_customers: "Clientes únicos",
  purchase_rate: "% con compra",
  active_days: "Días con venta",
  net_sales_per_day_90d: "Ventas/día (90 d)",
  change_90d_pct: "Cambio 90 d",
  net_sales_per_day_30d: "Ventas/día (30 d)",
  change_30d_pct: "Cambio 30 d",
  transactions_per_day_90d: "Tickets/día (90 d)",
  tx_per_day_change_90d_pct: "Cambio tickets/día",
  avg_ticket_90d: "Ticket prom. (90 d)",
  member_share_90d: "% con tarjeta",
  card_customers_90d: "Clientes con tarjeta",
  card_customers_change_90d_pct: "Cambio clientes",
  flags: "Alertas",
  location: "Sucursal",
  customers: "Clientes",
  share: "% del total",
  avg_spend: "Gasto promedio",
  total_spend: "Gasto total",
  matched: "Coinciden",
  reachable: "Contactables",
  excluded_no_consent: "Sin consentimiento",
  excluded_suspended: "Suspendidos",
  excluded_duplicates: "Duplicados",
  channel: "Canal",
  label: "Elemento",
  name: "Nombre",
  offer: "Oferta",
  sent: "Enviados",
  redemption_rate_pct: "Tasa de canje",
  attributed_gross_profit: "Utilidad atribuida",
  offer_cost: "Costo de oferta",
  profit_per_message: "Utilidad por mensaje",
  lift_pp: "Lift vs. control (pp)",
  control_size: "Grupo control",
  periodo: "Periodo",
  month: "Mes",
  price: "Precio",
  unit_cost: "Costo",
  unit_margin: "Margen unitario",
  rule: "Regla",
};

export const metricLabel = (k: string) => LABELS[k] ?? k;

export function formatMetric(key: string, value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value !== "number") return String(value);
  if (key === "member_share" || key === "purchase_rate") return formatPct(value);
  if (key === "margin_pct" || key.endsWith("_pct")) return `${formatNumber(value)}%`;
  if (key.endsWith("_rate") || key === "share" || key === "member_share_90d") return formatPct(value);
  if (key === "lift_pp") return `${value > 0 ? "+" : ""}${formatNumber(value)} pp`;
  if (/(sales|profit|ticket|discounts|spend|cost|revenue|price|margin)/.test(key)) return formatMXN(value);
  if (/(per_day)/.test(key)) return formatNumber(value);
  return formatInt(value);
}

export const isMoney = (key: string) => /(sales|profit|ticket|discounts)/.test(key);
